import React from "react"
import Layout from "../components/Layout/Layout"
import styles from "../style/license.module.css"
import { StaticImage } from "gatsby-plugin-image"

export default function license() {
  return (
    <div id="license-1">
      <Layout>
        <div className={styles.container}>
          <div className={styles.layout}>
            <div className={styles.wrapper}>
              <div className={styles.content}>
                <div className={styles.left}>
                  <h1 className="title">
                    {" "}
                    <span className="underline">Аудит</span>
                  </h1>
                  <h3>
                    Эрчим Хүчний Зохицуулах Хорооноос олгосон эрчим хүчний
                    аудиторын батламж
                  </h3>
                </div>
                <div>
                  <StaticImage
                    src="../images/audit_license 1.JPG"
                    alt="audit_license"
                    className={styles.image}
                  />
                </div>
                <div className={styles.left}>
                  <h3>
                    Европын Сэргээн Босголт Хөгжлийн Банкнаас зохион байгуулсан
                    Үйлдвэрлэлийн эрчим хүчний хэмнэлтийн ахисан түвшиний
                    сургалтын батламж{" "}
                  </h3>
                </div>
                <div>
                  <StaticImage
                    src="../images/eeii.JPG"
                    alt="eeii"
                    style={{ maxWidth: "500px" }}
                  />
                </div>
              </div>

              <div className={styles.content}>
                <div className={styles.left}>
                  <h1 className="title" id="license-2">
                    {" "}
                    <span className="underline">Сургалт</span>
                  </h1>
                  <h3>
                    Эрчим Хүчний Зохицуулах Хорооноос олгосон батламж Эрчим
                    хүчний хэмнэлтийн санхүү, эдийн засгийн шинжилгээний сургагч
                    багшийн батламж
                  </h3>
                </div>

                <div>
                  <StaticImage
                    src="../images/bagsh.JPG"
                    alt="bagsh_license"
                    style={{ maxWidth: "500px" }}
                  />
                </div>
              </div>

              <div className={styles.content}>
                <div className={styles.left}>
                  <h1 className="title" id="license-3">
                    {" "}
                    <span className="underline">ISO 50001 стандарт</span>
                  </h1>
                  <h3>
                    Эрчим хүчний удирдлагын тогтолцооны ISO 50001:2018
                    стандартыг хэрэгжүүлэгч PECB Олон Улсын Зөвлөх Үйлчилгээний
                    Байгууллагаас олгосон батламж
                  </h3>
                </div>
                <div>
                  <div className={styles.frame}>
                    <StaticImage
                      src="../images/iso50001.JPG"
                      alt="iso 50001"
                      style={{ maxWidth: "500px" }}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.content}>
                <div className={styles.left}>
                  <h1 className="title" id="license-4">
                    {" "}
                    <span className="underline">ЭХББ-ын төсөв</span>
                  </h1>
                  <h3>
                    Эрчим хүчний барилга байгууламжийн угсралт, засварын ажлын
                    хүрээний Мэргэшсэн төсөвчний батламж
                  </h3>
                </div>
                <div>
                  <div className={styles.frame}>
                    <StaticImage
                      src="../images/unnamed.jpg"
                      alt="tusuvchin"
                      style={{ maxWidth: "500px" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </div>
  )
}
